/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * The purpose of the payout. Possible values are

- self-use
- household
- personal-savings
- family-living-expenses

 */
export type CreatePayoutBodyPurpose = typeof CreatePayoutBodyPurpose[keyof typeof CreatePayoutBodyPurpose];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePayoutBodyPurpose = {
  'self-use': 'self-use',
  'buy-goods': 'buy-goods',
  spending: 'spending',
  household: 'household',
  payroll: 'payroll',
  'personal-savings': 'personal-savings',
  'family-living-expenses': 'family-living-expenses',
  'company-expense': 'company-expense',
} as const;
